// extracted by mini-css-extract-plugin
module.exports = {"note":"WarningNote_note__1YKeK","icon":"WarningNote_icon__3MGJq"};